// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RSStepHeaderItem_wrapper__hvr57","content":"RSStepHeaderItem_content__MTpqe","button--error":"RSStepHeaderItem_button--error___i_YP"};